/* eslint-disable func-names */

// Get the current UTC date and time in UK format
function getDateTimeUtcNowUkFormat() {
  const now = new Date();
  return new Intl.DateTimeFormat('en-GB', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    timeZone: 'Europe/London',
  }).format(now);
};

// Get the current year
function currentYear() {
  return new Date().getFullYear();
};

// Get the number of years between two dates
function getYearsBetween(startDate, endDate) {
  const start = new Date(startDate);
  const end = new Date(endDate);
  return end.getFullYear() - start.getFullYear();
};

// Get the number of months since a given date
function getMonthsSince(date) {
  const givenDate = new Date(date);
  const now = new Date();
  return (now.getFullYear() - givenDate.getFullYear()) * 12 + (now.getMonth() - givenDate.getMonth());
};

// Get the age from a date of birth
function getAgeFromDob(dob) {
  if (!dob) {
    return null;
  }

  const today = new Date();
  const birthDate = new Date(dob);
  let age = today.getFullYear() - birthDate.getFullYear();

  // Adjust if the birthday hasn't occurred yet this year
  const monthDiff = today.getMonth() - birthDate.getMonth();
  const dayDiff = today.getDate() - birthDate.getDate();
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }

  return age;
};

module.exports = {
  getDateTimeUtcNowUkFormat,
  currentYear,
  getYearsBetween,
  getMonthsSince,
  getAgeFromDob,
};